// extracted by mini-css-extract-plugin
export var container = "NewsTemplate-module--container--9-fZ4";
export var date = "NewsTemplate-module--date--2OUXh";
export var image = "NewsTemplate-module--image--Haa3Y";